import QtdModulo from '../../ModulosCrefito/QtdModulo'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import Publicidade from '../../ModulosCrefito/Modulos/Publicidade'
import PublicidadeRedeSocial from '../../ModulosCrefito/Modulos/PublicidadeRedeSocial'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const RedeSocial = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="REDE SOCIAL - PERFIL SOCIAL" modulo="idprofissional" />
            <PublicidadeRedeSocial modulo="idprofissional" />
            <QtdModulo texto="PUBLICIDADE" modulo="publicidade" />
            <Publicidade modulo="publicidade" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default RedeSocial